module.exports = __webpack_public_path__ + "img/ad-text.a3bf17ef.png";